export default "__VITE_ASSET__BQ9yIy7M__"